<template>
	<section class="existing-account-footer">
		<div class="existing-account-footer-container">
			Already have an account?
			<router-link :to="{ name: 'login' }">
				Sign in
			</router-link>
		</div>
	</section>
</template>


<script>
	export default {
		name: 'existing-login-footer'
	};
</script>


<style lang="scss">
@import '~@/assets/styles/references';

.existing-account-footer {
	flex: 1 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #f8f8f8;
}
.existing-account-footer-container {
	flex: 1 1 auto;
	color: color(black, secondary);
	padding: gx(1.5) gx(2);
}
</style>
